<div class="container d-flex justify-flex-end align-center pt-16" [ngClass]="{ 'container--modern': appearance === 'modern' }">
  <div
    class="dropdown d-flex justify-space-between align-center"
    *ngIf="showItemsPerPage"
  >
    <span class="dropdown-text">Linhas por página:</span>
    <select
      class="dropdown-select"
      name="dropdown-pagination"
      id="dropdown-pagination"
      [formControl]="pageControl"
    >
      <ng-container *ngFor="let option of options">
        <option [ngValue]="option" #option>{{ option }}</option>
      </ng-container>
    </select>
  </div>
  <button
    class="btn d-flex justify-center align-center"
    (click)="pageController.changePage(1, true)"
    [disabled]="disableButton(1)"
  >
    <app-svg-icon
      class="mr-2"
      src="../../../../assets/icons/double-arrow-left.svg"
      color="white"
      width="15px"
      height="10px"
      position="center"
    >
    </app-svg-icon>
  </button>

  <button
    class="btn d-flex justify-center align-center"
    (click)="pageController.changePage(1)"
    [disabled]="disableButton(1)"
  >
    <app-svg-icon
      class="mr-2"
      src="../../../../assets/icons/arrow-left.svg"
      color="white"
      width="10px"
      height="10px"
      position="center"
    >
    </app-svg-icon>
  </button>
  <div class="counter d-flex align-center">
    <span class="counter-emphasis d-flex justify-center align-center">
      {{ page }}
    </span>
    <span class="counter-total">de {{ totalPages || 1 }} </span>
  </div>

  <button
    class="btn d-flex justify-center align-center"
    (click)="pageController.changePage(2)"
    [disabled]="disableButton(2)"
  >
    <app-svg-icon
      class="ml-2"
      src="../../../../assets/icons/arrow-icon.svg"
      color="white"
      width="10px"
      height="10px"
      position="center"
    >
    </app-svg-icon>
  </button>
  <button
    class="btn rotate d-flex justify-center align-center"
    (click)="pageController.changePage(2, true)"
    [disabled]="disableButton(2)"
  >
    <app-svg-icon
      class="mr-1"
      src="../../../../assets/icons/double-arrow-left.svg"
      color="white"
      width="15px"
      height="10px"
      position="center"
    >
    </app-svg-icon>
  </button>
</div>
